import { __ } from "@wordpress/i18n";
import { SettingsContext } from "../../Settings";
import { useContext } from "react";

const PreserveSettingsSection = () => {
  const { register, settings } = useContext(SettingsContext);
  return (
    <div className="sb-tab-box sb-preserve-settings-box clearfix">
      <div className="tab-label">
        <h3>
          {__("Preserve settings if plugin is removed", "feeds-for-youtube")}
        </h3>
      </div>
      <div className="sby-tab-form-field">
        <div className="sb-form-field">
          <label htmlFor="preserve-settings" className="sby-checkbox">
            <input
              type="checkbox"
              id="preserve-settings"
              defaultChecked={settings.preserve_settings}
              {...register("preserve_settings")}
            />
            <span className="toggle-track">
              <div className="toggle-indicator"></div>
            </span>
          </label>
          <span className="help-text">
            {__(
              "This will make sure that all of your feeds and settings are still saved even if the plugin is uninstalled",
              "feeds-for-youtube"
            )}
          </span>
        </div>
      </div>
    </div>
  );
};
export default PreserveSettingsSection;
